module.exports = __webpack_public_path__ + "img/lotnisko2.f62c3d6d.jpg";